import { Component, Input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-drop-down',
  imports: [
    SvgIconComponent,
    RouterLink,
    RouterLinkActive,
    NgClass
  ],
  templateUrl: './drop-down.html',
  styleUrl: './drop-down.scss'
})

export class DropDown {
  @Input() classMenu!: null | string;

}
